import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { userDashboardApiIsomorphicFetchEvent } from '#/modules/userDashboard/api/userDashboardApiFetchEvent';
import { userDashboardEditEventRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { UserDashboardEditEventPageContainerLoadable } from './UserDashboardEditEventPageContainerLoadable';

export async function loader({
  request,
  context,
  params: { eventId },
}: HorizonAppRouteLoaderArgs<typeof userDashboardEditEventRoute>) {
  const [event] = await Promise.all([
    userDashboardApiIsomorphicFetchEvent({ request, context })(eventId),
    UserDashboardEditEventPageContainerLoadable.load(),
  ]);

  return { event };
}

export default function UserDashboardEditEventHorizonRoute({
  loaderData: { event },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Edit Event')}>
      <UserDashboardEditEventPageContainerLoadable event={event} />
    </RouteModule>
  );
}
